<template>
    <div class="overlay bg-primary text-white">
        <div class="spacer"></div>
        <div class="form-signin">
            <b-overlay
                :show="showOverlay"
            >
                <b-card
                    class="card-info"
                >
                    <slot name="header">
                        <div class="text-center mb-4">
                            <img v-if="group.logo_url" width="256" :src="group.logo_url" />
                            <logo-placeholder v-else size="lg" />
                        </div>
                        <h4>{{ title }}</h4>
                        <p v-if="subtitle">{{ subtitle }}</p>
                    </slot>
                    <b-alert
                        v-if="alert && typeof alert.success == 'boolean'"
                        :show="alert.message && alert.message.length > 0"
                        :variant="alert.variant"
                    >
                        {{ alert.message }}
                    </b-alert>
                    <slot></slot>
                </b-card>
                <template #overlay>
                    <slot name="overlay"></slot>
                </template>
            </b-overlay>
            <slot name="above-footer"></slot>
        </div>
        <div class="spacer"></div>
        <footer class="text-center">
            <p>
                &copy; 2024 Daniel Mitchell.
                <template v-if="group">
                    Made with <font-awesome-icon icon="heart"></font-awesome-icon> for {{ group.group_name }}.
                </template>
            </p>
        </footer>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import LogoPlaceholder from '@/components/logo/LogoPlaceholder.vue';
export default {
  components: { LogoPlaceholder },
    props: [
        "title",
        "subtitle",
        "alert",
        "show-overlay"
    ],
    data: function () {
        return {};
    },
    methods: {},
    computed: mapState(["user", "group"])
}
</script>
<style scoped>
.overlay {
    position: fixed;
    display: grid;
    align-content: center;
    width: 100%;
    height: 100%;
    overflow: auto;
}
.form-signin {
    width: 100%;
    max-width: 600px;
    margin: auto;
    margin-top: 50px;
    box-shadow: 0 0 50px #ccc;
    overflow: auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.spacer {
    flex-grow: 1;
}
footer {
    margin-top: 50px;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.card-info {
    flex-grow: 0;
    background-color: #ffffff; /* rgb(255, 255, 255, 0.1); */
    padding: 1rem;
    color: #000;
    /* background-color: rgba(0, 0, 0, 0.5); */
}
.text-white footer {
    color: #fff;
}
</style>